import http from '../../src/api/axiosConfig'

class ManageAPK {

    prefix = '/v1/web/apk/'

    loadApks() {
        return http.get(this.prefix+'list')
    }

    addApk(data) {
        console.log(data)
        return http.post(this.prefix+'upload', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    }

    publishApk(data) {
        console.log(data)
        return http.put(this.prefix+'publish',data)
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageAPK()